import { render, staticRenderFns } from "./THGUserActions.vue?vue&type=template&id=377fdddb&scoped=true"
import script from "./THGUserActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUserActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGUserActions.vue?vue&type=style&index=0&id=377fdddb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377fdddb",
  null
  
)

export default component.exports